import { authHeader } from '../../_helpers';
import axios from 'axios';

export const getPaAnanlyzeTeamListService = {
    getPaAnanlyzeTeamListServiceData,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')


function getPaAnanlyzeTeamListServiceData(id) {
    return axios.get(`/analytics/analyze/teams/list/${id}/?access_token=${token}`)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/Analyze/getPaAnanlyzeTeamList.service.js